import SpinLoader from '@components/SpinLoader/SpinLoader';
import AccessDenied from '@pages/AccessDenied/AccessDenied';
import NotFoundPage from '@pages/NotFoundPage/NotFoundPage';
import { authContext } from '@staffedupusa/shared-components';
import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
    element: JSX.Element;
    requiredRole?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    element,
    requiredRole,
}) => {
    const { authData } = useContext(authContext);
    const location = useLocation();
    const isCurrentPage = location.pathname;
    if (!authData?.isAuth) {
        return <NotFoundPage />;
    }

    if (authData.isAuth && !authData?.user) {
        return <SpinLoader />;
    }

    if (requiredRole === 'company' && !authData?.user?.company) {
        return <NotFoundPage />;
    }
    if (requiredRole === 'company' && authData?.user?.company && authData?.user?.company?.plan === 0 && isCurrentPage !== '/employer/account') {
        return <AccessDenied />;
    }

    if (requiredRole === 'company' && authData?.user?.company && authData?.user?.company?.is_suspicious && authData?.user?.company?.plan !== 0) {
        return <AccessDenied />;
    }

    if (requiredRole === 'company' && authData?.user?.company && !authData?.user?.enabled) {
        return <AccessDenied />;
    }

    if (requiredRole === 'enterprise' && !authData?.user?.enterprise) {
        return <NotFoundPage />;
    }
    
    if (requiredRole === 'admin' && !authData?.user?.is_admin) {
        return <NotFoundPage />;
    }

    if (requiredRole === 'rockerbox' && !authData?.user?.is_rockerbox) {
        return <NotFoundPage />;
    }
    if (
        requiredRole === 'applicant' &&
        (authData?.user?.is_admin ||
            authData?.user?.company ||
            authData?.user?.enterprise ||
            authData?.user?.is_rockerbox)
    ) {
        return <NotFoundPage />;
    }

    return element;
};
